import { css, type Component } from "dreamland/core";
import { router } from "dreamland/router";
import { auth } from "../api";

const Landing: Component<{}, {}> = function (cx) {
    cx.mount = () => {
        console.log("Landing component mounted");
        // If already authenticated, redirect to home
        if (auth.isAuthenticated()) {
            router.navigate("/home");
        }
    };

	return (
		<div class="page">
			<h1>tar</h1>
            <p>A lightweight Mastodon client, optimized for e-ink devices, and targeting Kindle devices on the latest firmware.</p>
            <p style="font-size: 0.8em; color: #555;">notice: tar [v{__APP_VERSION__}, {__COMMIT_HASH__}] is highly experimental software. here be dragons.</p>
            <p>some notes for those crazy enough to try:</p>
            <ul>
                <li>posting has not been added yet.</li>
                <li>you can't expand a post or view replies yet.</li>
                <li>i'm not sure how switching timelines should look like. therefore, i haven't implemented the feature yet.</li>
                <li>i haven't figured out how to update the visual state of the post action buttons yet. just assume you did the action when you click them</li>
            </ul>
            <br />
            <button class="primary" on:click={() => router.navigate("/login")}>
                <span class="material-symbols-sharp">login</span>
                Log In
            </button>
            <br /><br />
            <p style="font-size: 0.8em; color: #555;">made with <span class="material-symbols-sharp">favorite</span> by <a href="https://bomberfish.ca" target="_blank" rel="noopener noreferrer">bomberfish</a>. source code available under the MIT licence on <a href="https://github.com/bomberfish/tar" target="_blank" rel="noopener noreferrer">github</a>.</p>
		</div>
	);
};

Landing.style = css`
    p {
        margin-block: .8rem;
    }

    .material-symbols-sharp {
        font-size: 1em;
        vertical-align: middle;
        vertical-align: baseline;
        font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48;
    }
`

export default Landing;